import { getInitials } from "../utils/get-initials";
import { getDeterministicColor } from "../utils/get-deterministic-color";

type AvatarProps = {
  name: string;
  image?: string;
  size?: 'large' | 'medium' | 'small' | 'thumbnail' | 'default';
  disableTooltip?: boolean;
  shape?: 'circle' | 'square';
}

export function Avatar({ name, image, size, disableTooltip, shape }: AvatarProps) {
  if (!size) size = 'default';

  const initials = getInitials(name);
  const randomColor = getDeterministicColor(initials);
  const fontColor = '#FFFFFF';
  const sizeMap = {
    thumbnail: { circle: 22, fontSize: 10 },
    small: { circle: 28, fontSize: 12 },
    default: { circle: 36, fontSize: 12 },
    medium: { circle: 52, fontSize: 22 },
    large: { circle: 112, fontSize: 40 },
  };

  if (!image && !name) {
    return (
      <div
        style={{
          width: sizeMap[size].circle,
          height: sizeMap[size].circle,
          borderRadius: shape === "square" ? "12px" : "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: '#353535',
          border: '1px solid #303030',
          overflow: "hidden",
          fontSize: sizeMap[size].fontSize,
          fontWeight: size === "thumbnail" ? 600 : 400,
          color: fontColor,
          textTransform: "uppercase",
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: sizeMap[size].circle,
        height: sizeMap[size].circle,
        borderRadius: shape === "square" ? "12px" : "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: image ? "transparent" : randomColor,
        overflow: "hidden",
        fontSize: sizeMap[size].fontSize,
        fontWeight: size === "thumbnail" ? 600 : 400,
        color: fontColor,
        textTransform: "uppercase",
      }}
      title={disableTooltip ? undefined : name}
    >
      {image ? (
        <img
          src={image}
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: shape === "square" ? "12px" : "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        initials
      )}
    </div>
  );
}
